export const ITEM_MAINTENANCE_SET_SELECTED_TAB =
  'ITEM_MAINTENANCE_SET_SELECTED_TAB';
export const ITEM_MAINTENANCE_GRID_LOADING = 'ITEM_MAINTENANCE_GRID_LOADING';



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/settings/types.js